import { Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dcf-common-range',
  standalone: true,
  imports: [CommonModule, FormsModule],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DcfCommonRangeComponent), multi: true }],
  template: `
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Range</label>
      <div class="flex items-center space-x-3">
        <span class="text-sm text-gray-600">0</span>
        <input
          type="range"
          class="flex-1 h-2 bg-gray-200 rounded-lg"
          min="0"
          max="100"
          [(ngModel)]="value">
        <span class="text-sm text-gray-600">100</span>
        <span class="text-sm font-medium text-gray-900 min-w-[3rem] text-center">{{ value }}</span>
      </div>
    </div>
  `
})
export class DcfCommonRangeComponent implements ControlValueAccessor {
  value: number = 50;
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void { this.value = value || 50; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { }
}
